var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title', {
    staticClass: "text-h6 justify-center primary--text"
  }, [_vm._v(" CHECK AVAILABILITY ")]), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-row', {
    attrs: {
      "dense": "",
      "align": "center",
      "justify": "start"
    }
  }, [_c('v-col', {
    staticClass: "text-left",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "text-body-2 primary--text font-weight-bold mb-2"
  }, [_vm._v("Use the calendar below to find days this item is available for reservation.")]), _c('p', {
    staticClass: "text-body-2 primary--text font-weight-bold"
  }, [_vm._v("Dark, black dates signify availability.")])]), _c('v-col', {
    staticClass: "d-flex justify-center mt-2",
    attrs: {
      "cols": "2",
      "align-self": "center"
    }
  }, [_c('v-img', {
    staticClass: "pa-0",
    attrs: {
      "contain": "",
      "height": "70",
      "src": _vm.thumbnailSrc()
    }
  })], 1), _c('v-col', {
    staticClass: "ml-3",
    attrs: {
      "cols": "8"
    }
  }, [_c('v-row', {
    staticClass: "display-flex align-center justify-start",
    attrs: {
      "dense": ""
    }
  }, [_c('span', {
    staticClass: "font-weight-medium title primary--text"
  }, [_vm._v(" " + _vm._s(_vm.item.name) + " ")])]), _c('v-row', {
    staticClass: "display-flex flex-column align-start justify-start",
    attrs: {
      "dense": ""
    }
  }, [_c('div', [_c('v-avatar', {
    staticClass: "mr-1",
    attrs: {
      "size": "10",
      "color": _vm.categoriesById[_vm.item.category].color
    }
  }), _c('p', {
    staticClass: "font-italic subheading text-capitalize",
    staticStyle: {
      "display": "inline"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.categoriesById[_vm.item.category].name)
    }
  })], 1), _c('p', [_vm._v(_vm._s(("Reservation period: " + (_vm.item.reservation_length) + " Days")))])])], 1)], 1), _c('form', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center",
      "dense": ""
    }
  }, [_c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_vm.isLoading ? _c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": ""
    }
  }) : _c('v-date-picker', {
    staticClass: "mt-2",
    attrs: {
      "allowed-dates": _vm.allowedStart,
      "full-width": "",
      "no-title": "",
      "readonly": ""
    }
  })], 1)], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Close ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }